import React, { useState,useRef,useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";
import Icon from '../../../icons';
// import FieldRenderingEngine from "../../../components/FieldRenderingEngine";
import FieldDisplayEngine from "../../../components/FieldDisplayEngine";
import { RenderEngineKey,StringConstants,CombinedViewConstants } from '../constants';

import CombineViewGroup from "./combineViewGroup";
import { combinedViewDateKey, combinedViewTime } from "./dateKey";
import { useOrg } from "./actor";
import ListingComponent from '../../../components/ListingComponent';
import {renderImage} from '../../WorkkardDetail/utils';
import {PrintCombinedViewLoader} from '../../../components/SkeletonLoader';
import UserImage from '../../../components/UserImage/index';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';

const PROGRESS_FETCHING = 10;
const PROGRESS_RENDERED = 40;

const PrintCombinedView = (props) => {
    const CustomEngine = FieldDisplayEngine;
  

    let componentRef = useRef();
    const [index, setIndex] = useState(5);
    const [showSkeletonLoader, setSkeletonLoaderDisplay] = useState(true);
    const [isDocumentLoaded, setDocumentLoaded] = useState(false);
    const zoom = [0.6,0.7,0.75,0.80,0.90,1,1.1,1.20,1.3,1.4];
    const { combinedViewSettings,printData,workkard,isLoading,activityDetail } = useSelector(state => ({
        combinedViewSettings:state.workkardDetail.combinedView.settings,
        printData:state.workkardDetail.combinedView.printData,
        workkard: state.workkardDetail.workkardDetail,
        isLoading: state.isLoading,
        activityDetail:state.workkardDetail.activityDetail,
    }), shallowEqual);
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;
    // The owner organization's name used to ride along on the print payload as
    // KeyValueDictionary.WorkkardOwnerOrgName. The workkard detail carries only
    // the id, so the name comes from the shared org store the print saga warms.
    const ownerOrg = useOrg(workkard.SponsorOrgId || workkard.OrganizationId);
    // The bar used to move only while the print iframe's images loaded, so the
    // whole-timeline fetch that now precedes it left it frozen at 1%.
    const [progress, setProgress] = useState(PROGRESS_FETCHING);
    // Held in refs, not render-scoped `let`s: the cleanup in OnPopUpClose has to
    // clear the handles the effects actually set, otherwise the auto-print timer
    // outlives the closed modal and prints anyway.
    const timeOutPrint = useRef();
    const timeOutPrintWindow = useRef();
    const loaded = useRef();
    const counter = useRef(0);

    useEffect(() => {       
        document.addEventListener("load",handleDocumentReady());
      }, [isLoading]);

    const OnPopUpClose = () =>{
        document.removeEventListener("load",handleDocumentReady());
        setDocumentLoaded(false);
        setIndex(5);
        clearTimeout(timeOutPrintWindow.current);
        clearTimeout(timeOutPrint.current);
        clearTimeout(loaded.current);
        document.getElementById('printIframe') && document.getElementById('printIframe').contentWindow.close();
    }

    useEffect(()=>{
        if(printData.entries){
            setProgress((current) => Math.max(current, PROGRESS_RENDERED));
        }
    },[printData.entries]);

    useEffect(()=>{
        if(!showSkeletonLoader ){
            loaded.current = setTimeout(() => { setDocumentLoaded(true) }, 200);
        }        
    },[showSkeletonLoader]);
    useEffect(()=>{
        if(!isDocumentLoaded ){
            timeOutPrint.current=setTimeout(()=>{
                getPrintPreview()
            },3000);
        }        
        },[isDocumentLoaded]);
let getPrintPreview=()=>{
    
    let divContents = document.getElementById("printData") && document.getElementById("printData").innerHTML;
            if(document.getElementById('printIframe')){
                document.body.removeChild(document.getElementById('printIframe'))
            }
            let iframe = document.createElement('iframe');
            iframe.id = "printIframe"
            document.body.appendChild(iframe);
            iframe.contentWindow.document.body.innerHTML = divContents;
            const domDoc =iframe && iframe.contentWindow.document;
            const headEls = document.querySelectorAll("style, link[rel='stylesheet']");
            for (let i = 0, headElsLen = headEls.length; i < headElsLen; ++i) {
                if (headEls[i].tagName === "LINK") {
                    const newHeadEl = domDoc.createElement(headEls[i].tagName);
                    newHeadEl.rel ="stylesheet" ;
                    newHeadEl.type="text/css"
                    newHeadEl.href=headEls[i].href;
                    domDoc.head.appendChild(newHeadEl);
                }
            };
            
           let images= document.getElementById("printIframe").contentDocument.querySelectorAll(".filesMain img") || document.getElementById("printIframe").contentWindow.querySelectorAll(".filesMain img");
                if(images.length){
                    let total=images.length;
                    for(let image of images){ 
                        image.addEventListener("load", (e) => {
                            renderProgressBar(total);
                        })
                        image.addEventListener("error", (e) => {                            
                            image.src=renderImage("/images/notfound.png");
                            renderProgressBar(total);
                        })
                    }
                }
                else
                
                {
                    setProgress(100);
                    timeOutPrintWindow.current=setTimeout(()=>{
                        document.getElementById('printIframe').contentWindow.print();
                    },2000);
                }
                
}
    const handleDocumentReady = (event)=>{
    if(document.querySelectorAll("#printData").length && !isLoading){
        let images= document.querySelectorAll("#printData .filesMain img");
        if(images.length){
            for(let image of images){
                image.addEventListener("load", (e) => {  
                    counter.current++;
                    if(counter.current == images.length){
                        setSkeletonLoaderDisplay(false);
                    }
                })
                image.addEventListener("error", (e) => {
                    counter.current++;
                    image.src=renderImage("/images/notfound.png");
                    if(counter.current == images.length){
                        setSkeletonLoaderDisplay(false);
                    }
                })
            }
        }    
        else{
            setSkeletonLoaderDisplay(false);
        }        
        $('#printData a').removeAttr('href');            
    }
    };

    const renderProgressBar = (total) => {
        counter.current++;
        setProgress(PROGRESS_RENDERED + ((counter.current / total) * (100 - PROGRESS_RENDERED)));

        if (counter.current === total) {
            loaded.current = setTimeout(() => { setDocumentLoaded(true) }, 200);
            timeOutPrintWindow.current = setTimeout(() => {
                document.getElementById('printIframe').contentWindow.print();
            }, 3000);
        }
    } 

    const handlePrint = () => {
     if(isDocumentLoaded){
        getPrintPreview();
     }
    };    
    const zoomStyle = {
        transform : `scale(${zoom[index]})`,
        transformOrigin:'top'
    }

    const handleZoom = (type) => {
        const zoomLength = zoom.length;
        if((type<0 && index === 0 )|| (type >0 && index === zoomLength-1)){
            return;
        }
        let newIndex = 0;
        if(type === 0){
            newIndex = 5;
            setIndex(newIndex);
        } else {
            newIndex = type > 0 ? index+1 : index-1;
            setIndex(newIndex);
        }
    }

    useEffect(()=> {
        $(document).on('keydown', function(e) {
            if(e.ctrlKey && (e.key == "p" || e.charCode == 16 || e.charCode == 112 || e.keyCode == 80) ){
                handlePrint();
                e.cancelBubble = true;
                e.preventDefault();
                e.stopImmediatePropagation();
            }  
        });
        return () => {
            if(document.getElementById('printIframe')){
                document.body.removeChild(document.getElementById('printIframe'))
            }
        }
    },[])

    const renderCustomFields=(customFieldProps, showCreatedDate=false, showDescription=false)=> {
        if(workkard.CustomFields){
            return (
                <>
                    <CustomEngine userTimezone = {sessionContext.TimeZoneTz} tzData = {sessionContext.tzData} data={workkard.CustomFields} renderLocation={'detail'} renderType={'workkard'} {...customFieldProps}/>
                        {
                            (showCreatedDate && (workkard.CreatedDateString != null || workkard.CreatedDateString != "")) &&
                                <li>
                                    <label>Created Date</label>
                                    { workkard.CreatedDateString }
                                </li>
                        }
                <div className="wkDescription">
                    {
                        (showDescription) ?
                            <React.Fragment>
                                
                                    <label className="mb__8 mt">Description</label>
                                    <p dangerouslySetInnerHTML={{ __html: workkard.WorkkardSummary!="" ? workkard.WorkkardSummary :"-" }}></p>
                                
                            </React.Fragment>
                            :
                            ""
                    }
                </div>
                </>
            );
        }else
            return "";
    }

    const workkardDetailInfo=(workkard)=>{
        let workkardStatusClass = workkard && workkard.WorkkardStatus && workkard.WorkkardStatusForDisplay.toLowerCase()
        let WorkkardReopenReason = workkard && workkard.WorkkardStatusForDisplay === StringConstants.Reopened && workkard.WorkkardReopenReason;
        
        const workkardNumber = workkard.WorkkardNumber;
        return(
            <div className="cardDefaultInfo" >
                <div className="alignMiddle">
                   <div className="wkDetailNumber flexWrap alignMiddle">
                    <div className="wkColumn flexWrap">
                        <span className="wkNumber status">
                            {workkardNumber}
                        </span>
                        {" "}
                        <span className={"mr status " + workkardStatusClass + " workkardStatus"}>
                        {workkardStatusClass}{WorkkardReopenReason ? ` (${WorkkardReopenReason}${workkard.WorkkardReopenSubReason ? ` - ${workkard.WorkkardReopenSubReason}`: '' })` : ''}
                        </span>
                        </div>
                   </div>
                </div>
                {
                    renderCustomFields({
                        includeFields:[RenderEngineKey.CustomerName, RenderEngineKey.AdjusterName]
                    })
                }
            </div>
        )
    }

    const getExcludeFields = () => {
        let excludeFieldsArr = [RenderEngineKey.PropertyLocation, RenderEngineKey.CustomerName, 
            RenderEngineKey.AdjusterName,RenderEngineKey.CustomerEmail,RenderEngineKey.CustomerPhone];
            if(activityDetail.ownerOrgId ==activityDetail.assigneeOrgId)
            {
                return  [...excludeFieldsArr , RenderEngineKey.LossType ];
            }
            else if(activityDetail.ownerOrgId !=activityDetail.assigneeOrgId && activityDetail.activityOwnerId == userView.id)
            {
                return  [...excludeFieldsArr , RenderEngineKey.LossType ];
            }
            else{
                return  [...excludeFieldsArr, RenderEngineKey.ClaimSource,RenderEngineKey.LitigationWorkkardNumber , RenderEngineKey.LossType ];
            }
    
       
     }

    const renderCombineView=(cvData) =>{
        if(cvData && cvData.length > 0) {
            const dataIds = cvData.map(entry=>({
                id: entry.id,
                date: combinedViewDateKey(entry.occurred_at),
                time: combinedViewTime(entry.occurred_at),
                data: entry
            }));
            const groupDataIds = _.groupBy(dataIds, 'date');
            const workkardDetail=workkard;
            const hasFiles = (workkardDetail.DocCount+workkardDetail.PhotoCount+workkardDetail.VideoCount+workkardDetail.AudioCount+workkardDetail.EmailCount+workkardDetail.OtherCount) > 0 ? true : false;
            const prop = {
                data:Object.keys(groupDataIds).map(key=>({key,data:groupDataIds[key]})),
                cellTemplate: CombineViewGroup,
                onScrollHandler: ()=>false,
                onItemClick: () => false,
                type:"div",
                selectedId: '',
                classname:'colFlex flexGrow',
                extraData: { workkardId: workkard.Id, cvSettings: combinedViewSettings, hasFiles :hasFiles,isPrintPreview: true }
            }

            return (
                <ListingComponent {...prop}/>
            );
        }
        return null;
    }

    const cvData = (printData.entries || []).filter((entry) => !(
        entry.type === CombinedViewConstants.entryType.activityNote
        && !(entry.note && entry.note.body)
        && (!entry.files || entry.files.length === 0)
    ));

    return (
        <React.Fragment>
            <div className="header modalHeaderFixed">
                <div className="headerMain rowSpaceBetween">
                    <div className="rowFlex alignMiddle">
                    <div className="modalHeaderccLogo globalSearchccLogo">
                        <a href="javascript:void(0)" onClick={() => { window.location = `/workkards` }}><Icon name="CasheLogo" className="" /></a>
                    </div>
                    <div className="dFlex ml__1">
                        <h2 className="alignMiddle"> Print Preview</h2>
                    </div>
                    </div>
                    <div className="alignMiddle">
                        <span className="mt"> <a href="javascript:void(0)" data-quicktooltip="Print" onClick={handlePrint} className={`${isDocumentLoaded ?"quickTooltip-bottom":"disabled"}`}><Icon name="print" className="icon mr" /></a></span>
                        <span><a href="javascript:void(0)" className="btn btnGray" onClick={() => { OnPopUpClose(); props.onClose(); }}><Icon name="close" className="icon iconSmall mr" /> Close</a></span>
                    </div>
                </div>
                {
                    !isDocumentLoaded &&
                    <div className="progressLoader">
                        <div id="myBar"  className="progressBar" style={{width:`${progress}%`}}>
                        </div>
                    </div>
               }
            </div>
            {
                <div className="printCombinedView" >
                    <div className="modalBody">
                        <div className="countingPage modalContent" style={zoomStyle}  ref={componentRef} id="printData">
                            {
                                showSkeletonLoader ?
                                <div style={{height:"850px", paddingTop:"5px"}}>
                                    <PrintCombinedViewLoader />
                                </div>
                            :
                            printData.entries && workkard.Id &&
                            <div >
                                {
                                    workkard.WorkkardTitle &&
                                    <div className="textCenter lossTitle">{workkard.WorkkardTitle}</div>
                                }
                            <div className="ownerWorkkard pt__1 pb__8 pl__24 colFlex">
                                <ul className="rowFlex alignMiddle">
                                    <li className="subTitle">Workkard owner</li>
                                    <li> <UserImage profileUrl={workkard.SponsorImage} size="22" className="profileImage" profileName={`${workkard.SponsorFirstName} ${workkard.SponsorLastName}`} /> 
                                                 {`${workkard.SponsorFirstName} ${workkard.SponsorLastName}`}</li>
                                    {
                                        workkard.SponsorPhone &&
                                        <li><Icon name="mobile" className="icon mr" />{workkard.SponsorPhone}</li>
                                    }
                                    <li><Icon name="org" className="icon mr" />{ownerOrg.name}</li>
                                </ul>
                            </div>
                            <div className="alignMiddle bgGray pl__24 mb__18 printHeight">
                                <div className="colFlex">
                                    <div className="workkardMainInfo bgGray mt mb__10">
                                        {workkardDetailInfo(workkard)}
                                        <div className="colFlex propertyLocation wth-3">
                                            <ul className="rowFlex wrapFlex">
                                            {
                                                renderCustomFields({
                                                    includeFields: [RenderEngineKey.PropertyLocation]
                                                })
                                            }
                                            </ul>
                                        </div>
                                        { 
                                            workkard.CustomFields && workkard.CustomFields.length >0 &&
                                            <div className="ownerWorkkard">
                                                <ul>
                                                    <li><Icon name="mobile" className="icon mr" />
                                                        {
                                                            renderCustomFields({
                                                                includeFields:[RenderEngineKey.CustomerPhone],
                                                                showLabel:false,
                                                                returnValueForBlank:"NA"
                                                            })
                                                        }
                                                    </li>
                                                    <li><Icon name="email" className="icon mr" />
                                                    {
                                                        renderCustomFields({
                                                            includeFields:[RenderEngineKey.CustomerEmail],
                                                            showLabel:false,
                                                            returnValueForBlank:"NA"
                                                        })
                                                    }
                                                    </li>
                                                </ul>
                                            </div>
                                        }       
                                    </div>
                                </div>
                            </div>
                            <div className="wkDetailInfo col-3 ml__1-">
                                <ul className="rowFlex wrapFlex">
                                {
                                    workkard.CarrierName && (workkard.CarrierName.trim()!=null || workkard.CarrierName.trim()!="")?
                                    <li>
                                        <label>Carrier</label>
                                        <span>{workkard.CarrierName}</span>
                                    </li>
                                    :
                                    null
                                }

                                {
                                    renderCustomFields({
                                        excludeFields:getExcludeFields(false),
                                        showLabel:true
                                    })
                                }
                                 </ul>

                                {
                                    (workkard.CreatedDateString != null || workkard.CreatedDateString != "") &&
                                    <div className="wkDetailInfo col-3">
                                        <label>Created Date</label>
                                        { workkard.CreatedDateString }
                                    </div>
                                }
                            </div>
                            <div className="wkDescription pl__24">
                                <label className="mb__8 mt">Description</label>
                                {
                                    workkard.WorkkardSummaryFull ?
                                    <p className="descriptionFormating" dangerouslySetInnerHTML={{__html :workkard.WorkkardSummaryFull!="" ? workkard.WorkkardSummaryFull : "-"}}></p>
                                    :
                                    <p className="descriptionFormating" dangerouslySetInnerHTML={{__html :workkard.WorkkardSummary!="" ? workkard.WorkkardSummary :"-"}}></p>
                                }
                            </div>
                            <div className="combinedMainContainer detailMainContainer">
                                {
                                    renderCombineView(cvData)
                                }
                            </div>
                            <div className="copyright_ftr db">
                                © {new Date().getFullYear()} Exzeo USA, Inc. <a href="/agreement" target="_blank">User Contract</a><a href="/privacypolicy" target="_blank">Privacy Policy</a>
                            </div>
                        </div>
                        }
                        </div>
                        <div className="resetZoom">
                            <ul className="zoom">
                                <li>{zoom[index]*10*10}%</li>
                                <li onClick = {(e) => {e.stopPropagation();handleZoom(-1)}}><div className="decrease"></div></li>
                                <li onClick = {(e) => {e.stopPropagation();handleZoom(1)}}><div className="increase"></div></li>
                            </ul>     
                            <div onClick = {() => handleZoom(0)} className="reset"><a style={index !== 5 ? {color:'white'} :null }href="javascript:void(0);">reset</a></div>
                        </div>
                    </div>
                </div>
            }
           
    </React.Fragment>
    )
}




export default PrintCombinedView;

